import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {IncentivesResponse} from "../models/incentives.model";

@Injectable({
    providedIn: 'root'
})
export class IncentivesService {

    private apiUrl : string = `${environment.apiUrl}/incentive/`;

    constructor(private http: HttpClient) { }

    fetchIncentives(filters : any  = {}): Observable<IncentivesResponse> {

        let params = new HttpParams();

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                let formattedValue = value;

                if (value instanceof Date) {
                    // Format date in local time, not UTC
                    const year = value.getFullYear();
                    const month = String(value.getMonth() + 1).padStart(2, '0');
                    const day = String(value.getDate()).padStart(2, '0');
                    formattedValue = `${year}-${month}-${day}`;
                }

                params = params.set(key, String(formattedValue));

            }
        });

        return this.http.get<IncentivesResponse>(this.apiUrl, {params: params});

    }
}